import styled from '@emotion/styled'

export const UsersSettingsButtonsWrapper = styled.div`
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  padding: 12px;
`

export const UsersSettingsButtons = styled.button<{active: boolean, disabled: boolean, colorContrast: string}>`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background: ${({ active, colorContrast }) => (active ? colorContrast : 'transparent')};
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  height: 44px;
  line-height: 34px;
  margin: 8px;
  padding: 6px;
  width: 100px;

  &:hover {
    background-color: #f1f3f4;
    cursor: pointer;
  }
  
  &:disabled{
    cursor: not-allowed;
  }

`

export const UserSettingsAvatar = styled.img`
  border-radius: 50px;
  height: 25px;
  margin: 4px;
  width: 25px;
`

export const UserSettingsText = styled.p`
  color: #3c4043;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: .25px;
  margin: 0;
  opacity: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: none;
  white-space: nowrap;
`
